/**
* Image lazyloading
* BG: <div class="lazy" data-bg="url(../img/44721746JJ_15_a.jpg)"></div>
* IMG: <img class="lazy" data-src="../img/44721746JJ_15_a.jpg">
*/
function fnLazyLoad( i, oSection ) {

	var myLazyLoad = new LazyLoad({
	    elements_selector: '.lazy',
	    callback_enter : function(el) {
	    	$(el).addClass('lazy-loaded');
	    }
	});

};